import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { Routes } from 'react-router-dom'
import mapRouterHelper from '../../utils/MapRouterHelper'
import { DAT_XE_SHORT_PREFIX_URL } from './constants/config.dat-xe'
import PhieuDatXeRouters from './modules/phieu-dat-xe/PhieuDatXeRouters'
import XeRouters from './modules/xe/XeRouters'
import CarTypeRouters from './modules/car-type/CarType.Routers'
import CarBrandRouters from './modules/car-brand/CarBrand.Routers'
import AdminXeRouters from './modules/admin-xe/AdminXe.Routers'

const DatXeRouters: AppRouterItem[] = [
  {
    path: `${DAT_XE_SHORT_PREFIX_URL}/*`,
    element: (
      <Routes>
        {mapRouterHelper(XeRouters)}
        {mapRouterHelper(PhieuDatXeRouters)}
        {mapRouterHelper(CarTypeRouters)}
        {mapRouterHelper(CarBrandRouters)}
        {mapRouterHelper(AdminXeRouters)}
      </Routes>
    ),
  },
]

export default DatXeRouters
